export const DRAFT_TAP_BUSY_MIN_MS = 4_000;

const notedAt = new Map<string, number>();

export function draftTapBusyKey(card: { taskId: string; draftId: string }): string {
  return `${card.taskId}|${card.draftId}`.toLowerCase();
}

export function noteDraftTapBusy(key: string, now: number): void {
  notedAt.set(key, now);
}

export function clearDraftTapBusy(key: string): void {
  notedAt.delete(key);
}

export function draftTapBusyShown(key: string, busy: boolean, now: number): boolean {
  const at = notedAt.get(key);
  if (at === undefined) return false;
  if (busy || now - at < DRAFT_TAP_BUSY_MIN_MS) return true;
  notedAt.delete(key);
  return false;
}

export function draftTapBusyLeftMs(key: string, now: number): number {
  const at = notedAt.get(key);
  return at === undefined ? 0 : Math.max(0, at + DRAFT_TAP_BUSY_MIN_MS - now);
}
